<style>
  .vdp-datepicker {
    position: relative !important;
    width: 300px;
  }

  .vdp-datepicker__calendar {
    top: 26px !important;
    width: 100% !important;
    left: 0;
  }
</style>
<template>
  <div>
    <div class="is-flex is-centered">
      <div
        v-if="selectedFranchise.name"
        class="field"
      >
        <div class="control is-flex">
          <label class="label mr-1">Franchise:</label>
          <div
            class="dropdown"
            :class="{'is-active': franchiseDropdown}"
          >
            <div class="dropdown-trigger">
              <button
                class="button is-small"
                aria-haspopup="true"
                aria-controls="dropdown-menu"
                @click="franchiseDropdown = !franchiseDropdown"
              >
                <span>{{ selectedFranchise.name }}</span>
                <span class="icon is-small">
                  <i
                    class="far fa-angle-down"
                    aria-hidden="true"
                  />
                </span>
              </button>
            </div>
            <div
              class="dropdown-menu"
              role="menu"
            >
              <div
                v-for="franchise in franchises"
                class="dropdown-content"
              >
                <a
                  class="dropdown-item"
                  @click="selectFranchise(franchise)"
                >
                  {{ franchise.name }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom:1.1rem;">
        <date-picker
          v-model="date"
          class="input-date"
          minimum-view="month"
          format="MMMM yyyy"
          placeholder="Select Date"
        />
      </div>
    </div>
    <div class="is-flex flex-wrap late-tournament">
      <div
        v-for="tournament in tournaments"
        class="box mb-0 m-1"
      >
        <router-link :to="`/tournaments/${tournament.tournId}`">
          <strong class="is-size-7-touch">{{ tournament.tournName }}</strong>
          <span class="has-text-danger is-block is-size-7-touch">{{ tournament.franchiseName }}</span>
          <span class="has-text-info is-size-7-touch">{{ tournament.franchiseOwner }}</span>
          <div>
            <span class="is-size-7">Added: {{ tournament.addedDate }}</span>
            <span class="is-size-7"> by {{ tournament.addedBy }}</span>
          </div>
          <div class="is-size-7">
            Date: {{ tournament.tournDate }}
          </div>
          <div class="is-size-7">
            Late by: {{ tournament.lateBy }}
          </div>
        </router-link>
      </div>
    </div>
    <div
      v-if="notFound"
      class="has-text-centered block-content"
    >
      <h5 class="subtitle is-5">
        There are no late tournaments for this date
      </h5>
      <img
        src="/images/dps.png"
        width="280"
      >
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import DatePicker from '../../helpers/Datepicker.vue'

  export default {
    name: 'LateTournaments',
    components: {DatePicker},
    props: ['user', 'token'],
    data() {
      return {
        franchises: [],
        selectedFranchise: {},
        franchiseDropdown: false,
        date: null,
        tournaments: [],
        notFound: false
      }
    },
    watch: {
      date(val) {
        this.getLateTournaments(val)
      }
    },
    mounted() {
      this.getFranchises()
    },
    methods: {
      getFranchises() {
        this.date = ''
        this.sessions = []
        let url = `admin/tournaments/getfranchises`
        let data = {
          token: this.token
        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.franchises = res.data
            this.selectedFranchise = res.data[0]
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true,message: error.response.data.message})
          })
      },
      selectFranchise(franchise) {
        this.selectedFranchise = franchise
        this.franchiseDropdown = false
      },
      getLateTournaments(date) {
        if (!date) return false
        this.notFound = false
        let filterYear = this.$moment(date).format('YYYY')
        let filterMonth = this.$moment(date).format('M')
        let filterFranchise = this.selectedFranchise.id
        let url = `admin/tournaments/late`
        let data = {
          filterYear,
          filterMonth,
          filterFranchise,
          token: this.token
        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.tournaments = res.data
            if (!res.data.length) this.notFound = true
          })
          .catch((error) => {
            this.$emit('message', {error: true,showDialog: true, message: error.response.data.message})
          })
      }
    }
  }
</script>
